module.exports = __webpack_public_path__ + "core-img/error-bg.b12956c74975a3b6db87875d562b0de8.png";


//////////////////
// WEBPACK FOOTER
// ./src/main/ui/core/gfx/images/debug-renderer/error-bg.png
// module id = 34
// module chunks = 0